import Imatge from 'components/corporatiu/Imatge';
import styles from './projectesfinancatsmarato.module.scss';
import __isEmpty from 'lodash/isEmpty';
import Boto from 'components/corporatiu/Boto';

const ProjectesFinancatsMarato = ({ texts, projectes, textsAny }) => {
    return (
        <>
            <div className={styles.header}>
                <h1 dangerouslySetInnerHTML={{ __html: textsAny.projectes_financats_title }}></h1>
                <Boto text={texts.projectes_financats_tots} link={texts.projectes_financats_path} tema='marato' />
            </div>
            <div className={styles.text}>
                <Imatge
                    src={textsAny.projectes_financats_img}
                    alt='Cartell Marató'
                    width={341}
                    height={194}
                    className={styles.imatge}
                />
                <div dangerouslySetInnerHTML={{ __html: textsAny.projectes_financats_text }}></div>
            </div>
            <div className={styles.projectes}>
                {!__isEmpty(projectes) &&
                    projectes.map((projecte, index) => (
                        <div key={index} className={styles.projecte}>
                            <h2 dangerouslySetInnerHTML={{ __html: projecte.titol }}></h2>
                            <div dangerouslySetInnerHTML={{ __html: projecte.autor }}></div>
                            <div className={styles.euros}>
                                {texts.projectes_financats_financament}: <span>{projecte.euros}</span>
                            </div>
                        </div>
                    ))}
            </div>
        </>
    );
};

export default ProjectesFinancatsMarato;
